import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export type TApiError = FetchBaseQueryError & {
    data: {
        message: string;
    };
};

export function isApiError(error: unknown): error is TApiError {
    if (typeof error !== 'object' || error === null || !('status' in error) || !('data' in error)) return false;

    const { data } = error;
    return typeof data === 'object' && data !== null && 'message' in data && typeof data.message === 'string';
}
